export const importExport = {
  exportEntries: {
    exportToCsv: 'Export to Excel(.csv)',
    exportToExcel: 'Export to Excel(.csv)',
    exportPDF: 'Export PDF',
    exportTemplate: 'Download Sample Template',
    exportMessage:
      'The Excel file will be automatically downloaded to your device. If not, check your browser settings.',
    columnNames: {
      code: 'Code',
      quantity: 'Quantity',
      name: 'Name',
      price: 'Total Item Price',
      partNumber: 'Part Number',
      catalogNumber: 'Catalog Number',
    },
    exportProductToCsv: 'Export Products to Excel(.csv)',
  },
  importEntries: {
    importProducts: 'Import Products',
    label: 'Loaded File',
  },
  importEntriesDialog: {
    importProducts: 'Import Products',
    importProductsSubtitle: 'Add products by importing a .CSV file.',
    importProductsNewSavedCartSubtitle: 'Add products by importing a .CSV file and creating a new saved cart.',
    importProductFileDetails:
      'The text file must contain a list of products with required columns separated by commas: SKU and quantity.',
    selectFile: 'Select File',
    savedCartName: 'Saved Cart Name',
    savedCartDescription: 'Saved Cart Description',
    optional: 'optional',
    charactersLeft: 'remaining characters: {{count}}',
    cancel: 'Cancel',
    upload: 'Upload',
    close: 'Close',
    summary: {
      info: 'Do not close or refresh this window while products are being imported.',
      loadedToCart: 'Products have been loaded into cart {{ cartName }}',
      loaded: 'Products have been loaded',
      loading: 'Products are being processed... ({{ count }}/{{ total }})',
      successes: '{{ successesCount }} out of {{ total }} products were imported successfully.',
      warning: '{{ count }} product was not fully imported.',
      warning_other: '{{ count }} products were not fully imported.',
      error: '{{ count }} product was not imported.',
      error_other: '{{ count }} products were not imported.',
      messages: {
        unknownIdentifier: 'SKU of the product "{{ productCode }}" does not exist.',
        lowStock: 'Quantity for {{ productName }}: {{ quantity }} has been reduced to {{ quantityAdded }}.',
        noStock: '{{ productName }} is currently out of stock.',
        unknownError: 'Unrecognized issue with "{{ productCode }}".',
        limitExceeded: 'Cannot add "{{ productCode }}". Limit exceeded.',
      },
      show: 'Show',
      hide: 'Hide',
    },
  },
};
